export default "__VITE_PUBLIC_ASSET__8987c9b0__"